module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4804-2177b6a2ffb78f6a8ccdfaf79e4cfa91.jpg";